// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd6f98cf","259":"339d64f5","455":"faa1f030","762":"bc089cc7"}[chunkId] + ".chunk.js";
};